import { motion } from "framer-motion";

export function SectionTitle({ tag, title, className = "" }) {
  return (
    <div className={`mb-10 ${className}`}>
      {tag && <div className="font-mono-fk text-xs tracking-widest text-[#FF5757] mb-2">{tag}</div>}
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="font-display text-4xl sm:text-5xl"
      >
        {title}
      </motion.h2>
    </div>
  );
}

export function Pill({ children, color = "#FFD93D" }) {
  return (
    <span className="font-mono-fk text-xs fk-border rounded-full px-3 py-1" style={{ background: color }}>
      {children}
    </span>
  );
}
